export * from "./glTFLoader.pure";

import { RegisterGLTF2Loader } from "./glTFLoader.pure";

RegisterGLTF2Loader();
